import React from "react";
import { useTranslation } from "react-i18next";
import FileUpload from "../../utils/fileUpdload";
import personProvider from "../../../../static/images/personProvider.svg";

const FileProvider = (props) => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <div className="main-addProvider">
        <div className="header-providers">
          <div className="title">
            <img src={personProvider} className="icon" />
            <p className="p-list">{t(`providers.new.file`)}</p>
          </div>
          <div className="actions flex-element left-flex report-download">
            <p>{t(`general.labels.downloadExample`)}</p>
            <a href={`/static/documents/plantilla_proveedores.csv`}>CSV</a>
          </div>
        </div>
        <FileUpload
          needToken={props.needToken}
          postUrl={`/providers/me/massive`}
        />
      </div>
    </React.Fragment>
  );
};

export default FileProvider;
